<template>
    <div class="login-form">
        <form @submit.prevent="submit" ref="registro-form-form"
              :class="{
                'validated': validated
            }"
              novalidate
              v-if="!isSubmitting && typeof this.$route.query.operador === 'undefined' ">

            <div v-if="!cuentaCreada">
                <div v-if="errors!=null">
                    <ul>
                        <li class="text-danger" v-for="error in errors">
                            {{ error }}
                        </li>
                    </ul>
                </div>
                <div class="form-group">
                    <label for="registro-form-email">Email</label>
                    <input type="email"
                           :class="{
                                'form-control': true,
                                'is-invalid': validated && (email == '' || !isEmailValid),
                                'is-valid': validated && isEmailValid && email != ''
                            }"
                           name="email"
                           id="registro-form-email"
                           aria-describedby="emailHelp"
                           placeholder="Email"
                           required
                           autocomplete="off"
                           v-model="email">
                    <div class="invalid-feedback">Email inválido</div>
                    <div class="valid-feedback" v-if="validated && email != user.email"></div>
                </div>
                <div class="form-group">
                    <label for="registro-form-password">Password</label>
                    <input type="password"
                           :class="{
                                'form-control': true,
                                'is-invalid': validated && (password == ''),
                                'is-valid': validated && password != ''
                            }"
                           name="password"
                           id="registro-form-password"
                           placeholder="Nuevo password"
                           autocomplete="off"
                           v-model="password">
                    <div class="invalid-feedback">Password inválido</div>
                </div>
                <!-- <div class="form-group">
                     <label for="registro-form-repeat">Repetir password</label>
                     <input type="password"
                         :class="{
                             'form-control': true,
                             'is-invalid': validated && (repeatPassword == '' || password != repeatPassword),
                             'is-valid': validated && repeatPassword != '' && password == repeatPassword
                         }"
                         name="repeat-password"
                         id="registro-form-repeat"
                         placeholder="Repetir nuevo password"
                         v-model="repeatPassword">
                     <div class="invalid-feedback">El password no coincide</div>
                 </div> -->
                <div class="text-center">
                    <button class="btn btn-primary gtm-registro-header">
                        CREAR CUENTA
                    </button>
                    <hr>
                    <a href="#login" class="btn btn-secondary"
                       title="Iniciar sesión"
                       @click="toggleLoginModal(true)">
                        Iniciar sesión
                    </a>
                </div>
                <br>
                <div class="perfil-alert color-red"
                     v-if="alert.visible">
                    <font-awesome-icon
                        :icon="alert.icon"
                        class="color-red"
                        :class="{
                        spin: alert.iconSpin
                    }"/>
                    {{ alert.message }}
                </div>
            </div>
            <div v-else
                 class="text-center alert-text-box">

                <p v-if="this.$route.name=='checkout'"> Redireccionando...</p>
                <p v-else>Activa tu cuenta desde el link que hemos enviado a tu correo</p>

            </div>

        </form>
        <form @submit.prevent="submitTelefono"
              ref="registro-form-form"
              :class="{
                'validated': validated
            }"
              novalidate
              v-if="!isSubmitting && typeof this.$route.query.operador !== 'undefined' ">

            <div v-if="!cuentaCreada">

                <div class="form-group">
                    <label for="registro-form-email">Número de teléfono</label>
                    <input type="number"
                           :class="{
                                'form-control': true,
                                'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                'is-valid': validated && isTelefonoValid && telefono != ''
                            }"
                           name="email"
                           id="registro-form-telefono"
                           aria-describedby="telefonoHelp"
                           placeholder="Número de teléfono Ej: 912345678"
                           required
                           autocomplete="off"
                           v-model="telefono">
                    <div class="invalid-feedback">Teléfono inválido</div>
                    <div class="valid-feedback" v-if="validated && telefono != user.telefono"></div>
                </div>

                <div class="text-center">
                    <button class="btn btn-primary gtm-registro-header">
                        CREAR CUENTA
                    </button>
                </div>
                <br>
                <div class="perfil-alert color-red"
                     v-if="alert.visible">
                    <font-awesome-icon
                        :icon="alert.icon"
                        class="color-red"
                        :class="{
                        spin: alert.iconSpin
                    }"/>
                    {{ alert.message }}
                </div>
            </div>
            <div v-else
                 class="text-center alert-text-box">
                <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
            </div>

        </form>
    </div>
</template>

<script>
import Vue from "vue";
import {mapGetters} from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {randomString, isValidEmail, isValidTelefono} from "../utilities/util";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faCheck,
    faSpinner,
    faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import DatePicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import {es as dpes} from "vuejs-datepicker/dist/locale";
import {format, toDate} from "date-fns";
import {es} from "date-fns/esm/locale";


library.add(faCheck, faSpinner, faExclamationTriangle);

export default {
    components: {
        VueGoogleAutocomplete,
        FontAwesomeIcon,
        DatePicker
    },
    props: ["countrySlug"],
    data() {
        return {
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false
            },
            id: 0,
            name: "",
            apellido: "",
            email: "",
            label: null,
            telefono: "",
            direccion: "",
            isSubmitting: false,
            password: "",
            repeatPassword: "",
            validated: false,
            termino_condicion: false,
            fecha_nac: this.getToday(),
            sexo: "",
            es,
            dpes,
            disabledDates: {from: this.getToday()},
            cuentaCreada: false,
            activarCuentaCheckout: 0,
            errors: null
        };
    },
    computed: {
        isEmailValid() {
            return isValidEmail(this.email);
        },
        isTelefonoValid() {
            return isValidTelefono(this.telefono);
        },
        ...mapGetters(["user", "portal"])
    },
    methods: {
        /**
         * Prevenir submit del form al escoger una dirección de google.
         */
        direccionKeyPress(e) {
            if (e.key == "Enter") {
                e.preventDefault();
                return false;
            }
        },
        /**
         * Prevenir submit del form al escoger una dirección de google.
         */
        direccionKeyUp(e) {
            if (e.key == "Enter") {
                e.preventDefault();
                return false;
            }
        },
        newDireccion(obj1, obj2, obj3) {
            this.direccion = obj1.newVal;
        },
        toggleLoginModal(toggle) {
            this.$store.commit("togglePortalLoginModal", toggle);
            this.$store.commit("togglePortalRegistroModal", false);
        },
        submit(e) {
            this.validated = true;
            this.errors = null
            let isValid = true;
            if (
                !this.isEmailValid ||
                //	this.password != this.repeatPassword ||
                this.password == ""
            )
                isValid = false;

            if (!isValid) return false;


            if (this.$route.name == "checkout") {
                this.activarCuentaCheckout = 1;

            }

            let newUserData = {
                usuario: this.email,
                activarCuentaCheckout: this.activarCuentaCheckout,
                name: this.name,
                apellido: this.apellido,
                email: this.email,
                telefono: this.telefono,
                direccion: this.direccion,
                termino_condicion: this.termino_condicion ? 1 : 0,
                password: this.password,
                sexo: this.sexo,
                fecha_nac: format(this.fecha_nac, "yyyy-MM-dd"),
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
                codigo_referido: localStorage.getItem("code_referred"),
            };

            if (isValid) {
                this.showAlert({
                    iconSpin: true,
                    message: "Guardando...",
                    icon: "spinner"
                });
                this.$store
                    .dispatch("registro", newUserData)
                    .then(response => {
                        this.showAlert(
                            {
                                message: response.message,
                                icon: "check",
                                iconSpin: false
                            },
                            true
                        );
                        localStorage.removeItem("code_referred");
                        fbq('track', 'CompleteRegistration');
                        dataLayer.push({
                            'event': 'registro-creado',
                        });

                        if (this.email != "" && this.password != "") {
                            this.$store
                                .dispatch("login", {
                                    email: this.email,
                                    password: this.password,
                                })
                                .then(response => {
                                    this.$emit("loginSuccessful", response);

                                    if (this.$route.name == "checkout") {
                                        this.$store.dispatch("checkUserActivado", "checkout");
                                        document.querySelector("#pagar_curso").click();
                                        setTimeout(() => {
                                            this.$store.commit("toggleCompletarPerfilModalVisible", false);
                                        }, 200);

                                    } else {
                                        setTimeout(() => {
                                            window.reload();
                                        }, 1000);
                                    }
                                })
                                .catch(error => {
                                    this.ButtonActivarEnvioCorreo = false;
                                    if (error == "USER INACTIVO") {
                                        this.ButtonActivarEnvioCorreo = true;
                                    }
                                    this.loginMessage =
                                        "Error al iniciar sesión, revise el email y el password.";
                                    this.loginMessageShow = true;
                                    this.$emit("loginError", error);
                                    this.isSubmitting = false;
                                });
                        }
                        this.email = "";
                        this.password = "";
                        this.repeatPassword = "";
                        this.cuentaCreada = true;
                    })
                    .catch(error => {
                        console.log({error});
                        this.errors = error.data
                        this.showAlert(
                            {
                                message: error.message,
                                icon: "exclamation-triangle",
                                iconSpin: false
                            },
                            false
                        );
                    });
            }
        },
        submitTelefono(e) {
            console.log("submit telefono");
            this.validated = true;
            let isValid = true;
            if (
                !this.isTelefonoValid
            )
                isValid = false;

            if (!isValid) return false;


            if (this.$route.name == "checkout") {
                this.activarCuentaCheckout = 1;

            }

            let newUserData = {
                usuario: this.email,
                activarCuentaCheckout: this.activarCuentaCheckout,
                name: this.name,
                apellido: this.apellido,
                email: this.email,
                telefono: this.telefono,
                direccion: this.direccion,
                termino_condicion: this.termino_condicion ? 1 : 0,
                password: this.password,
                sexo: this.sexo,
                fecha_nac: format(this.fecha_nac, "yyyy-MM-dd"),
                registro_telefono: 1,
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),

            };

            if (isValid) {
                console.log("valido");
                this.showAlert({
                    iconSpin: true,
                    message: "Guardando...",
                    icon: "spinner"
                });
                this.$store
                    .dispatch("registro", newUserData)
                    .then(response => {


                        this.showAlert(
                            {
                                message:
                                    "Registro exitoso",
                                icon: "check",
                                iconSpin: false
                            },
                            true
                        );


                        fbq('track', 'CompleteRegistration');

                        dataLayer.push({
                            'event': 'registro-creado',
                        });

                        if (this.$route.name == "checkout") {

                            if (this.telefono != "") {
                                this.$store
                                    .dispatch("login", {
                                        telefono: this.telefono,
                                        validarEntrada: "CHECKOUT",
                                    })
                                    .then(response => {
                                        this.$emit("loginSuccessful", response);
                                        localStorage.setItem("telefono_suscribir", this.telefono);

                                        document.querySelector("#pagar_curso").click();
                                        setTimeout(() => {
                                            this.$store.commit("toggleCompletarPerfilModalVisible", false);
                                        }, 200);


                                    })
                                    .catch(error => {
                                        this.ButtonActivarEnvioCorreo = false;
                                        if (error == "USER INACTIVO") {
                                            this.ButtonActivarEnvioCorreo = true;
                                        }
                                        this.loginMessage =
                                            "Error al registrar, revise teléfono";
                                        this.loginMessageShow = true;
                                        this.$emit("loginError", error);
                                        this.isSubmitting = false;
                                        this.showAlert({
                                                message:
                                                this.loginMessage,
                                                iconSpin: false
                                            },
                                            true
                                        );

                                    });
                            }

                        }


                        //this.telefono = "";
                        // this.cuentaCreada=true;


                    })
                    .catch(error => {
                        console.log({error});
                        /*let message =
                            "Hubo un error en el registro, por favor intente de nuevo.";*/
                        if (error.data.data == "EXISTE") {


                            if (this.telefono != "") {
                                this.$store
                                    .dispatch("login", {
                                        telefono: this.telefono,
                                        validarEntrada: "CHECKOUT",
                                    })
                                    .then(response => {
                                        this.$emit("loginSuccessful", response);
                                        localStorage.setItem("telefono_suscribir", this.telefono);

                                        document.querySelector("#pagar_curso").click();
                                        setTimeout(() => {
                                            this.$store.commit("toggleCompletarPerfilModalVisible", false);
                                        }, 200);


                                    })
                                    .catch(error => {
                                        this.ButtonActivarEnvioCorreo = false;
                                        if (error == "USER INACTIVO") {
                                            this.ButtonActivarEnvioCorreo = true;
                                        }
                                        this.loginMessage =
                                            "Error al registrar, revise teléfono";
                                        this.loginMessageShow = true;
                                        this.$emit("loginError", error);
                                        this.isSubmitting = false;
                                        this.showAlert({
                                                message:
                                                this.loginMessage,
                                                iconSpin: false
                                            },
                                            true
                                        );

                                    });
                            }


                            /*message =
                                "Ya tenemos un usuario registrado con este email ó teléfono, por favor revisa tu email e intenta de nuevo.";*/
                        }
                        this.showAlert(
                            {
                                message,
                                icon: "exclamation-triangle",
                                iconSpin: false
                            },
                            false
                        );
                    });
            }
        }
        ,
        showAlert(options, autoHide) {
            this.alert.visible = true;
            this.alert = Object.assign(this.alert, options);
            if (autoHide)
                setTimeout(() => {
                    this.alert.visible = false;
                }, 3000);
        },
        getToday() {
            let d = new Date();
            return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }
    },
    mounted() {
        if (this.$route.name == "CheckoutFinish" && typeof this.$route.query.telefono !== 'undefined') {

            this.telefono = this.$route.query.telefono;

            if (this.telefono != "") {
                this.$store
                    .dispatch("login", {
                        telefono: this.telefono,
                        validarEntrada: "CHECKOUT",
                    })
                    .then(response => {
                        this.$emit("loginSuccessful", response);

                    })
                    .catch(error => {
                        this.ButtonActivarEnvioCorreo = false;
                        if (error == "USER INACTIVO") {
                            this.ButtonActivarEnvioCorreo = true;
                        }
                        this.loginMessage =
                            "Error al registrar, revise teléfono";
                        this.loginMessageShow = true;
                        this.$emit("loginError", error);
                        this.isSubmitting = false;
                        this.showAlert({
                                message:
                                this.loginMessage,
                                iconSpin: false
                            },
                            true
                        );

                    });
            }

        }
    },
};
</script>
